import { ApplicationRef, EmbeddedViewRef, Injectable, Renderer2, RendererFactory2, TemplateRef } from '@angular/core';

@Injectable()
export class MarqueeDomService {
  private r: Renderer2;
  constructor(rf: RendererFactory2) {
    this.r = rf.createRenderer(null, null);
  }

  cloneInto(src: HTMLElement, dst: HTMLElement) {
    while (dst.firstChild) dst.removeChild(dst.firstChild);
    Array.from(src.childNodes).forEach(n => dst.appendChild(n.cloneNode(true)));
  }

  createCloneFrom(src: HTMLElement, className = 'marquee-item'): HTMLElement {
    const node = this.r.createElement('div') as HTMLDivElement;
    node.className = className;
    node.setAttribute('aria-hidden', 'true');
    this.cloneInto(src, node);
    return node;
  }

  mountTemplateInto(dst: HTMLElement, tpl: TemplateRef<unknown>, appRef: ApplicationRef): EmbeddedViewRef<unknown> {
    while (dst.firstChild) dst.removeChild(dst.firstChild);

    const view = tpl.createEmbeddedView({});
    appRef.attachView(view);
    for (const node of view.rootNodes) {
      this.r.appendChild(dst, node);
    }
    view.detectChanges();
    return view;
  }

  unmountView(view: EmbeddedViewRef<unknown>, appRef: ApplicationRef) {
    try {
      view.destroy();
    } catch {}
    try {
      appRef.detachView(view);
    } catch {}
  }

  measureWidth(el: HTMLElement): number {
    const rect = el.getBoundingClientRect();
    return Math.max(rect.width, el.scrollWidth, el.offsetWidth, 1);
  }
  measureHeight(el: HTMLElement): number {
    const rect = el.getBoundingClientRect();
    return Math.max(rect.height, el.scrollHeight, el.offsetHeight, 1);
  }

  setHidden(el: HTMLElement, hidden: boolean) {
    if (hidden) el.classList.add('is-hidden');
    else el.classList.remove('is-hidden');
  }
  applyTranslateX(el: HTMLElement, x: number) {
    el.style.transform = `translate3d(${x}px,0,0)`;
  }
}
